module.exports = __webpack_public_path__ + "img/IWD.bccc0753.jpg";